import React from 'react';
import './Services.css';
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";

const Services = (props) => {

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const services = [
    {
    title: 'Zaštita ličnih podataka',
    icon: 'fa fa-shield',
    items: [
      'Usklađivanje sa Zakonom o ZLP',
      'Procjena uticaja (DPIA)',
      'Analiza rizika',
      'Kompletna pravna dokumentacija',
      'IT podrška / tehničke mjere',
      'Izrada internih evidencija',
      'Savjetovanje i edukacija',
      'Eksterni službenik za ZLP (DPO)',
    ],
  },
        {
      title: 'IT',
      icon: 'fa fa-laptop',
      items: [
        'Izrada Web stranica',
        'Održavanje Web stranica',
        'Mobilne aplikacije',
        'Politike sigurnosti',
        'Optimizacija IT sistema',
        'Savjetovanje',
      ],
    },
    {
      title: 'Pravo',
      icon: 'fa fa-balance-scale',
      items: [
        'Registracija privrednih društava',
        'Registracija udruženja',
        'Javne nabavke',
        'Pravni savjeti',
        'Izrada ugovora',
        'Izrada statuta',
      ],
    },
    {
      title: 'Marketing',
      icon: 'fa fa-bullhorn',
      items: [
        'Digitalni marketing',
        'Direktni marketing',
        'SEO optimizacija',
        'Google ads',
        'Istraživanje tržišta',
        'Leci',
        'Vizit karte',
      ],
    },
/*
    {
      title: 'Administracija',
      icon: 'fa fa-paperclip',
      items: [
        'Prikupljanje dokumenata',
        'Rad sa institucijama',
        'Popunjavanje obrazaca',
        'Digitalizacija',
        'Praćenje rokova',
      ],
    },
    */
  ];

  return (
    <div className="services-container fade-in" id={props.id}>
      <ScreenHeading 
      title={'Usluge'}
      subHeading={'Istaknute oblasti djelovanja'}
      />
      <div className="services-row">
  {services.slice(0, 2).map((service, index) => (
    <div key={index} className="service-card">
      <i className={`${service.icon} service-icon`}></i>
      <h3>{service.title}</h3>
      <ul>
        {service.items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </div>
  ))}
</div>

<div className="services-row">
  {services.slice(2).map((service, index) => (
    <div key={index} className="service-card">
      <i className={`${service.icon} service-icon`}></i>
      <h3>{service.title}</h3>
      <ul>
        {service.items.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </div>
  ))}
</div>
<div className="dpo-info-block">
  <h3>Šta je službenik za zaštitu ličnih podataka (DPO)?</h3>
  <p>
    Službenik za zaštitu ličnih podataka (DPO) je lice koje prema Zakonu (član 40.) mora da posjeduje stručno znanje o pravu i praksi iz oblasti zaštite 
    ličnih podataka, a zaduženo je za informisanje i savjetovanje uprave i zaposlenih vezano za obradu ličnih podataka, praćenje usklađenosti sa Zakonom o
    zaštiti ličnih podataka, GDPR standardima i drugim relevantnim zakonima, te komunikaciju i saradnju sa
    Agencijom za zaštitu ličnih podataka. Magna pruža usluge eksternog
    DPO-a za kompanije koje žele profesionalan i pouzdan nadzor nad
    obradom podataka.
  </p>
</div>

    </div>
  );
};

export default Services;
